
import {Component, Vue} from 'vue-property-decorator'
import {getContentList} from '@/api/content'
import {getPriceList, getTaskList} from '@/api/home'
import {getCurrentUserBill} from '@/api/manager'
import {UserModule} from "@/store/module/user";
import {IPaginationData} from "@/@types/global";
import {GetOverview} from '@/api/agency';
import {eventBus} from "@/main";

@Component({
	name: 'HomePage'
})
export default class HomePage extends Vue {
	// 轮播图
	bannerList: any[] = []
	state1: string = ''
	taskList: any = []
	listData: any[] = []
	iconList = [
		'活动专区',
		'盲盒专区',
		'Mobile Check',
		'Line',
		'WhatsApp',
		'Telegram',
		'Zalo',
		'Signal',
		'Skype',
		'Facebook',
		'Instagram',
		'Binance',
		'Linkedin',
		'Microsoft',
		'Twitter',
		'Amazon',
		'Viber',
		'成品代筛',
		'SnapChat',
		'kakaotalk',
		'Wish',
		'MoMo',
		'botim',
		'okx',
		'htx',
		'bybit',
		'mint',
		'gate',
		'platform-manage',
		'platform',
		'tiktok'
	]
	idList = [
		'active_',
		'blind',
		'phone',
		'line',
		'ws',
		'tg',
		'zalo',
		'signal',
		'skype',
		'fb',
		'ins',
		'binance',
		'linkedin',
		'ms',
		'twitter',
		'amazon',
		'viber',
		'agent',
		'snapchat',
		'kakao',
		'wish',
		'momo',
		'botim',
		'okx',
		'htx',
		'bybit',
		'mint',
		'gate',
		'event',
		'black',
		'tiktok'
	]
	// 提交反馈
	Contacts = ''
	Content = ''

	//代理

	searchData = {
		name: ''
	}
	paginationData: IPaginationData = {
		// 表单数据
		currentPage: 1,
		sizes: [10, 30, 50, 100],
		pageSize: 50,
		total: 0
	}
	isLoading = false
	dialogVisible = false
	IncomeList: any = []
	promotionList: any = []

	get filteredList(): string[] {
		const keyword = this.state1
		if (!keyword) return this.listData

		const regex = new RegExp(keyword, 'i')  // 'i' 表示忽略大小写

		return this.listData.filter(product =>
			regex.test(product.Name + product.Platform + product.PlatformName)
		)
	}

	querySearch(queryString: any, cb: any) {
		const product = this.listData;
		const results = queryString ? product.filter(this.createFilter(queryString)) : product;
		// 调用 callback 返回建议列表的数据
		cb(results);
	}

	createFilter(queryString: any) {
		// 将查询字符串转换为正则表达式
		const regex = new RegExp(queryString.split('').join('.*'), 'i');
		return (product: any) => {
			return regex.test(product.Name + product.Platform + product.PlatformName);
		};
	}

	clickIcon(code:any, subItem:any) {
		eventBus.$emit('clickPriceTask', code, subItem);
	}

	handleSelect() {

	}

	get userRole() {
		return UserModule.userInfo.roleID
	}

	get userInfo() {
		return UserModule.userInfo
	}

	copyLink(value: string) {
		if (navigator.clipboard && window.isSecureContext) {
			navigator.clipboard.writeText(value)
			this.$message.success('复制成功')
		} else {
			this.$message.error('当前环境不支持复制')
		}
	}

	// 点击搜索
	handleSearch() {
		this.paginationData.currentPage = 1
	}

	handleReset() {
		this.searchData.name = ''
	}

	handleSizeChange(val: number) {
		this.paginationData.pageSize = val
	}

	handleCurrentChange(val: number) {
		this.paginationData.currentPage = val
	}

	mounted() {
		this.initBanner()
		this.initStatus()
		this.initAgency()
	}

	handleDrump(url: string) {
		if (!url || url === 'undefined') return
		window.open(url)
	}

	async initAgency() {
		await GetOverview()
			.then((res: any) => {
				const title = ['充值统计', '消费统计']
				const iconList = [require('@/assets/充值@3x.png'), require('@/assets/消费@3x.png')]
				const bgLink = [require('@/assets/充值b.png'), require('@/assets/消费b.png')]
				const cssList = ['cztj', 'xftj']
				let arr = [
					[
						{
							name: '本月充值',
							price: res.data.MonthTotalCharge
						},
						{
							name: '本月下线充值',
							price: res.data.MonthRefersTotalCharge
						}
					],
					[
						{
							name: '本月消费',
							price: res.data.MonthTotalCost
						},
						{
							name: '本月下线消费',
							price: res.data.MonthRefersTotalCost
						}
					],
					// [
					// 	{
					// 		name: '总推广人数',
					// 		price: res.data.Refers
					// 	},
					// 	{
					// 		name: '本月新增推广',
					// 		price: res.data.MonthRefers
					// 	}
					// ]
				]

				this.promotionList = [
					{
						name: '总推广人数',
						price: res.data.Refers
					},
					{
						name: '本月新增推广',
						price: res.data.MonthRefers
					}
				]
				for (let i = 0; i < arr.length; i++) {
					let obj = {data: arr[i], icon: iconList[i], bg: bgLink[i], css: cssList[i], title: title[i]}
					this.IncomeList.push(obj)
				}
			})
	}

	initBanner() {
		const params = {
			classCode: 'banner',
			pageNum: 1,
			limit: 3
		}
		getContentList(params).then(res => {
			this.bannerList = res.data
		})
	}

	initStatus() {
		// getTaskList()
		// 	.then(res => {
		// 		this.taskList = []
		// 		res.data.forEach((item: any) => {
		// 			const index = this.iconList.indexOf(item.Platform)
		// 			if (index >= 0) {
		// 				this.taskList.push({
		// 					...item,
		// 					icon: this.idList[index] && require(`@/assets/img/st/${this.idList[index]}.png`)
		// 				})
		// 			} else {
		// 				this.taskList.push({
		// 					...item,
		// 					icon: require(`@/assets/img/st/${item.Platform.toLowerCase()}.png`)
		// 				})
		// 			}
		// 		})
		// 	})
		// 	.catch(err => {
		//
		// 		this.$message.error(err.msg)
		// 	})


		getPriceList()
			.then(res => {
				this.listData = []
				const normalList: any = [];
				const upgradingList: any = [];
				res.data.forEach((item: any) => {
					const index = this.idList.indexOf(item.Platform)
					const formattedItem = {
						...item,
						status: item.CanOrder === 1 ? '正常' : '升级中',
						icon: this.iconList[index] && require(`@/assets/img/${this.iconList[index]}.png`)
					};
					if (formattedItem.status === '正常') {
						normalList.push(formattedItem);
					} else {
						upgradingList.push(formattedItem);
					}
				})
				this.listData = [...normalList, ...upgradingList];
				console.log('listData===>', this.listData);
			})
			.catch(err => {
				console.log(err)
				this.$message.error(err.msg)
			})

		// getCurrentUserBill()
		// 	.then(res => {
		// 		this.banlance = res.data
		// 	})
		// 	.catch(err => {
		// 		this.$message.error(err.msg)
		// 	})
	}

	//
	// handleSubmit() {
	// 	const data = {
	// 		Contacts: this.Contacts,
	// 		Content: this.Content
	// 	}
	// 	if (!this.Contacts) {
	// 		this.$message.warning('请输入联系方式')
	// 	} else if (!this.Content) {
	// 		this.$message.warning('请输入反馈内容')
	// 	} else {
	// 		submitFeedback(data)
	// 			.then(() => {
	// 				this.$message.success('反馈成功')
	// 				this.Contacts = ''
	// 				this.Content = ''
	// 			})
	// 			.catch(err => {
	// 				this.$message.error(err.msg)
	// 			})
	// 	}
	// }
}
